import React, { useState, useRef, useEffect } from 'react'
// import Button from '../button/button'
import './textAreaComment.scss'
import { siteUrl } from '../../../shared/utils/siteUrl'
import Loader from 'react-loader-spinner'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'

const TextAreaComment = ({
  max,
  setContent,
  action,
  buttonLoading,
  colorError,
}) => {
  const [charCounter, setCharCounter] = useState(0)
  const textArea = useRef(null)

  const [errorChar, setErrorChar] = useState(false)
  const handleOnTextChange = () => {
    setCharCounter(textArea.current.value.length)
    setContent(textArea.current.value)
  }

  const handleAction = () => {
    if (charCounter < 50) {
      setErrorChar(true)
      return
    }

    pushEventDataLayer('Interacciones - historias', 'Cur-v', 'Click', 'Enviar')
    action()
    textArea.current.value = ''
    setCharCounter(0)
  }

  useEffect(() => {
    if (charCounter > 50) {
      setErrorChar(false)
    }
  }, [charCounter])

  const handleOnBlurTextarea = () => {
    if (localStorage.getItem('TOKEN_INFO') === null) {
      sessionStorage.setItem(
        'NEXT_PAGE',
        window.location.pathname + '#zona-virtual'
      )
      window.location.href = siteUrl + '/login/'
    }
  }

  return (
    <div className="f-text-area-comment">
      <textarea
        name=""
        id=""
        onFocus={() => handleOnBlurTextarea()}
        placeholder={
          ['es-AR', 'es-PY', 'es-UY'].includes(process.env.LOCALE)
            ? 'Escribí acá una historia única sobre tu menstruación...'
            : 'Escribe aquí esa historia única…'
        }
        onChange={handleOnTextChange}
        ref={textArea}
        autoCapitalize="sentences"
        maxLength={max}
      />
      <span className="counter">
        {charCounter}/{max}
      </span>
      {errorChar && (
        <p className={`f-text-area-comment__error ${colorError}`}>
          Recuerda que tu historia debe tener mínimo 50 caracteres
        </p>
      )}
      <div className="button">
        <button
          className="new-dark-blue"
          onClick={action && handleAction}
          disabled={buttonLoading}
        >
          {buttonLoading ? (
            <Loader type="TailSpin" color="#ffffff" height={20} width={20} />
          ) : (
            'Enviar'
          )}
        </button>
      </div>
    </div>
  )
}

export default TextAreaComment
